import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import baseURL from '../Common/Config';
import Axiosfetch from '../Common/Axiosfetch';
import Alert from 'react-s-alert';
import FailureAlert from '../Common/Failure';
import * as yup from 'yup';
import { ValidateRole, CallBackAlert } from '../Common/Validations/validation';
import IsUndefinedNullOrEmpty from '../Common/Validations/valueCheck';

const Role = {
    Name: "",
    Description: "",
    IsDeleted: 0
};

const RoleSchema = yup.object().shape({
    Name: yup.string().trim().required()
});

const AddRoles = ({ themeColor, hiderole, getRole, edit, roledetail, allRole }) => {

    const [roleData, setRoleData] = useState(Role);

    useEffect(() => {
        if (parseInt(edit) === 1) {
            setRoleData(roledetail);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onTextChange = (e) => {
        let value = e.target.value;
        setRoleData({ ...roleData, [e.target.name]: value });
    };

    const SaveRoleDetails = (role) => {
        RoleSchema.validate(role).then(valid => {
            if (ValidateRole(role, allRole)) {
                var roledata = {
                    Name: role.Name.trim(),
                    Description: IsUndefinedNullOrEmpty(role.Description) ? null : role.Description,
                    ID: role._id
                }

                Axiosfetch(baseURL + ((parseInt(edit) === 0) ? "CreateRole" : "EditRole"), "POST", roledata, RoleDetailsSuccess, Failure);
            }
        }).catch(err => {
            Alert.error(err.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        });
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const RoleDetailsSuccess = (data) => {
        if (data.success) {
            hiderole();
            getRole();
        }

        CallBackAlert(data);
    };

    return (
        <div>
            <div id="addProduct" className="modal" style={{ display: "block" }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${themeColor}`}>
                        <h4 style={{ marginLeft: "5px" }}>{parseInt(edit) === 0 ? "Add" : "Edit"} Role</h4>
                        <span className="close" onClick={hiderole}>&times;</span>
                    </div>

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>
                                    <h4>Role Name<span className="mandatoryStar">*</span></h4>
                                </td>
                                <td>
                                    <input type="text" name="Name"
                                        className="form-control"
                                        onChange={e => onTextChange(e)}
                                        value={roleData.Name}></input>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h4>Description</h4>
                                </td>
                                <td>
                                    <input type="text" name="Description"
                                        className="form-control"
                                        onChange={e => onTextChange(e)}
                                        value={roleData.Description}></input>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2" style={{ textAlign: "right" }}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${themeColor}Focus`} onClick={() => SaveRoleDetails(roleData)}>Save</button>
                                            <button type="button" className="btn btn-default" onClick={hiderole}>Close</button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default AddRoles;